import React from 'react';
import { SHOWN_STIMULUS_TEXT } from '../../constants/eyetrackingConstants';
import type { ShownStimulus } from './pipedMedia';
import { shownImages } from './shownStimulus';

interface Props {
  stimulus: ShownStimulus;
  resolveUrl: (url: string) => string;
}

/** What a per-respondent question showed this respondent, as labelled thumbnails. */
const ShownStimulusThumbs: React.FC<Props> = ({ stimulus, resolveUrl }) => {
  const images = shownImages(stimulus);
  if (images.length === 0) return null;
  return (
    <div className="mt-2" data-testid="shown-stimulus">
      <div className="mb-1 text-xs font-medium text-gray-500">{SHOWN_STIMULUS_TEXT.title}</div>
      <div className="flex flex-wrap gap-3">
        {images.map((img) => (
          <figure key={img.url} className="w-28">
            <img
              src={resolveUrl(img.url)}
              alt={img.label}
              className="h-28 w-28 rounded border border-gray-200 bg-white object-contain"
            />
            <figcaption className="mt-1 truncate text-xs text-gray-600">{img.label}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
};

export default ShownStimulusThumbs;
